// extracted by mini-css-extract-plugin
export default {"list":"Home_list__DuUVn","item":"Home_item__jS08T","box":"Home_box__wOiHN","image":"Home_image__0C1IU","name":"Home_name__APRnb"};